import React from "react";
import {useHistory} from "react-router";
import {Box, Button, Text} from "theme-ui";
import {Inline} from "@bedrock-layout/inline";

function FormControls() {
    const history = useHistory();
    const handleRouting = () => {
        history.push('/management/tenant/create')
    }
    return (
        <Box variant="layout.header.form-controls" alignItems="center">
            <Inline gutter='md' align="start" stretch="start">
                <Text variant="section">Tenant Management</Text>
                <Button variant="primary" onClick={handleRouting}>Create</Button>
                <Button variant="primary.outlined" onClick={() => history.push('/management/code-flags')}>Bulk code flags</Button>
            </Inline>
        </Box>
    )
}

export default FormControls;